export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return OnHeaderPropertyChanged(state, action);
    case 'OnHeaderSaving':
      return OnHeaderSaving(state, action);
    case 'OnReportXPartnerTypePropertyChanged':
      return onReportXPartnerTypePropertyChanged(state, action);
    case 'OnReportXPartnerTypeAdded':
      return onReportXPartnerTypeAdded(state, action);
    case 'OnReportPartnerTypesSaved':
      return onReportPartnerTypesSaved(state, action);
    case 'OnReportXDocumentPropertyChanged':
      return onReportXDocumentPropertyChanged(state, action);
    case 'OnReportXDocumentTypeAdded':
      return onReportXDocumentTypeAdded(state, action);
    case 'OnReportXDocumentTypeDeleted':
      return onReportXDocumentTypeDeleted(state, action);
    case 'OnReportXDocumentTypesSaved':
      return onReportXDocumentTypesSaved(state, action);

    default:
      return state;
  }
}
export const initialState = {
  header: {
    reportId: null,
    reportName: '',
    reportFriendlyName: '',
    orderNumber: '',
    changed: false,
    reportXPartnerTypesChanged: false,
    reportXDocumentTypesChanged: false,
    reportXPartnerTypeIds: [],
    reportXPartnerTypes: [],
    reportXDocumentTypeIds: [],
    reportXDocumentTypes: [],
    showInDocument: false,
    showInPartner: false,
    showInReportList: false,
    isSensitiveInfo: false
  }
};

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    header: {
      ...state.header,
      reportId: data.reportId,
      reportName: data.reportName,
      reportFriendlyName: data.reportFriendlyName,
      orderNumber: data.orderNumber,
      showInReportList: data.showInReportList,
      showInPartner: data.showInPartner,
      showInDocument: data.showInDocument,
      isSensitiveInfo: data.isSensitiveInfo,
      openMode: data.openMode,
      reportType: data.reportType,
      storedProcedureName: data.storedProcedureName,
      countStoredProcedureName: data.countStoredProcedureName,
      changed: false,
      //partner types
      reportXPartnerTypes: data.reportXPartnerTypes,
      reportXPartnerTypeIds: data.reportXPartnerTypes.map(x => x.partnerTypeId),
      //document types
      reportXDocumentTypes: data.reportXDocumentTypes,
      reportXDocumentTypeIds: data.reportXDocumentTypes.map(x => x.documentTypeId)
    }
  };
}

function OnHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;

  let payload = {
    ...state,
    header: {
      ...state.header,
      [propertyName]: value,
      changed: true
    }
  };

  if (propertyName === 'showInDocument' && !value) {
    payload = {
      ...payload,
      header: {
        ...payload.header,
        reportXDocumentTypeIds: [],
        reportXDocumentTypes: []
      }
    };
  }

  if (propertyName === 'showInPartner' && !value) {
    payload = {
      ...payload,
      header: {
        ...payload.header,
        reportXPartnerTypeIds: [],
        reportXPartnerTypes: []
      }
    };
  }

  if (propertyName === 'partnerTypeIds') {
    payload = {
      ...state,
      header: {
        ...state.header,
        reportXPartnerTypeIds: value,
        reportXPartnerTypes: value?.map(x => {
          return {
            reportId: state.header.reportId,
            partnerTypeId: x
          };
        }),
        changed: true
      }
    };
  }

  if (propertyName === 'documentTypeIds') {
    payload = {
      ...state,
      header: {
        ...state.header,
        reportXDocumentTypeIds: value,
        reportXDocumentTypes: value?.map(x => {
          return {
            reportId: state.header.reportId,
            documentTypeId: x
          };
        }),
        changed: true
      }
    };
  }

  return {
    ...state,
    ...payload
  };
}

function OnHeaderSaving(state) {
  return {
    ...state,
    header: {
      ...state.header,
      changed: false
    }
  };
}

function onReportXDocumentTypeDeleted(state, action) {
  const { index } = action;
  const newReportXDocumentTypes = Object.assign([...state.reportXDocumentTypes]);
  newReportXDocumentTypes.splice(index, 1);
  return {
    ...state,
    header: {
      ...state.header,
      reportXDocumentTypesChanged: true
    },
    reportXDocumentTypes: newReportXDocumentTypes
  };
}

function onReportXPartnerTypeAdded(state, _action) {
  const reportXPartnerType = {
    partnerTypeId: ''
  };
  const newReportXPartnerTypes = Object.assign([...state.reportXPartnerTypes]);
  newReportXPartnerTypes.push({ ...reportXPartnerType, changed: true });
  return {
    ...state,
    header: {
      ...state.header
    },
    reportXPartnerTypes: newReportXPartnerTypes
  };
}

function onReportXDocumentTypeAdded(state, _action) {
  const reportXDocumentType = {
    documentTypeId: ''
  };
  const newReportXDocumentTypes = Object.assign([...state.reportXDocumentTypes]);
  newReportXDocumentTypes.push({ ...reportXDocumentType, changed: true });
  return {
    ...state,
    header: {
      ...state.header
    },
    reportXDocumentTypes: newReportXDocumentTypes
  };
}

function onReportXPartnerTypePropertyChanged(state, action) {
  const { propertyName, value, index } = action;
  return {
    ...state,
    header: {
      ...state.header,
      reportXPartnerTypesChanged: true
    },
    reportXPartnerTypes: Object.assign([...state.reportXPartnerTypes], {
      [index]: {
        ...state.reportXPartnerTypes[index],
        [propertyName]: value,
        changed: true
      }
    })
  };
}

function onReportXDocumentPropertyChanged(state, action) {
  const { propertyName, value, index } = action;
  return {
    ...state,
    header: {
      ...state.header,
      reportXDocumentTypesChanged: true
    },
    reportXDocumentTypes: Object.assign([...state.reportXDocumentTypes], {
      [index]: {
        ...state.reportXDocumentTypes[index],
        [propertyName]: value,
        changed: true
      }
    })
  };
}

function onReportPartnerTypesSaved(state, _action) {
  return {
    ...state,
    header: {
      ...state.header,
      reportXPartnerTypesChanged: false
    }
  };
}

function onReportXDocumentTypesSaved(state, _action) {
  return {
    ...state,
    header: {
      ...state.header,
      reportXDocumentTypesChanged: false
    }
  };
}
